import settings from '../settings.json';
import Settings from './types';

export class AppSettings {
    static Settings: Settings = undefined

    static get(property) {
      if (!AppSettings.Settings) {
        return fetch(<any>settings)
          .then(response => response.json())
          .then((data) => {
            AppSettings.Settings = data
            return this.Settings[property]
          })
      } else {
        return AppSettings.Settings[property]
      }
    }
}
